function onDialogDisplayed() {}

export default onDialogDisplayed;
